import EmojiRatingPage from "@components/EmojiRatingPage"

export default function LooksmaxxingStyleFeelingPage() {
  return (
    <EmojiRatingPage
      translationKey="styleFeelingLooksmaxxing"
      leftLabelKey="notHappy"
      rightLabelKey="loveIt"
    />
  )
}
